import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";

const urlBase = `${process.env.API_URL}/candidatosNP`;
const readUrl = (url = "") => `${urlBase}/${url}`;

export const getAllCandidatos = async (params) => {
  const query = new URLSearchParams(params);

  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(`allCandidatos?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);
  return res.success;
};

export const postCandidatoNPMain = async (candidato) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(`main-module`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(candidato),
  });
  res = await res.json();

  // setea el formato de error para mostrar el toast con la funcion handleErrors
  if (res.httpCode === 500) {
    const data = { message: res.message, isSoftError: true };
    throw data;
  }

  return res.success;
};

export const patchCandidatoNpMain = async (id, candidato) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(`main-module/${id}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(candidato),
  });
  res = await res.json();
  return res.success;
};

export const uploadCandidatosMain = async ({ files }) => {
  const auth = `Bearer ${getToken()}`;

  const formData = new FormData();
  Array.from(files).forEach((file) => {
    formData.append("candidatosNP", file);
  });

  let res = await fetch(readUrl(`bulk-only-candidatosNP-import`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
    },
    body: formData,
  });

  res = await res.json();

  if (res.httpCode === 409) {
    const data = res.message;
    return { message: data.message, result: data.result, repetidos: true };
  }

  if (res.httpCode === 422) return { message: res.message.message, error: true };

  if (!res.success) return res;
  return res.success;
};

export const multiPatchCandidatosNpMain = async (candidatos) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`main-module/estados`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(candidatos),
  });
  res = await parseJSON(res);

  return res.success;
};

export const multiAsociateCandidatesNPsMain = async (candidatos) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`main-module/asociate`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(candidatos),
  });
  res = await res.json();

  if (res.httpCode === 409) {
    const data = res.message;
    return { message: data.message, result: data.result, repetidos: true };
  }

  if (!res.success) throw res;
  return res.success;
};
export const postCandidatoNP = async (candidato) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(``), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(candidato),
  });

  res = await res.json();

  if (res.httpCode === 409) {
    const data = res.message;
    return { message: data.message, result: data.result, repetidos: true };
  }

  if (!res.success) throw res;
  return res.success;
};

export const multiPostCandidatosNp = async (candidatos) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(`multi`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(candidatos),
  });

  res = await parseJSON(res);

  return res.success;
};

export const patchCandidatoNp = async (itemId, candidato) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`${itemId}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(candidato),
  });

  res = await parseJSON(res);

  return res.success;
};

export const multiPatchCandidatosNp = async (candidatos) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/estados`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(candidatos),
  });

  res = await parseJSON(res);

  return res.success;
};

export const getCandidatosByDerivacion = async (id, notaDePedidoId) => {
  if (id && id !== "undefined" && notaDePedidoId && notaDePedidoId !== "undefined") {
    const auth = `Bearer ${getToken()}`;
    try {
      let res = await fetch(readUrl(`all/${id}?notaDePedidoId=${notaDePedidoId}`), {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: auth,
          "Content-Type": "application/json",
        },
      });
      res = await parseJSON(res);

      return res.success;
    } catch (error) {
      return [];
    }
  }
  return [];
};
export const getCandidatosByNP = async (id) => {
  const auth = `Bearer ${getToken()}`;
  if (!id || id === "undefined") return [];

  let res = await fetch(readUrl(`allByNP/${id}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);
  return res.success;
};

export const uploadCandidatos = async ({ notaDePedidoId, files }) => {
  const auth = `Bearer ${getToken()}`;

  const formData = new FormData();
  Array.from(files).forEach((file) => {
    formData.append("candidatosNP", file);
    formData.append("notaDePedidoId", notaDePedidoId);
  });

  let res = await fetch(readUrl(`bulk-candidatosNP-import`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
    },
    body: formData,
  });

  res = await res.json();

  if (res.httpCode === 409) {
    const data = res.message;
    return { message: data.message, result: data.result, repetidos: true };
  }

  if (res.httpCode === 422) return { message: res.message.message, error: true };

  if (!res.success) return res;
  return res.success;
};

export const postMarkAsReadedCandidato = async (candidato) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(`leido`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(candidato),
  });

  res = await parseJSON(res);

  return res.success;
};

export const getMedicalStudies = async (candidatoNPId, params) => {
  const query = params ? new URLSearchParams(params) : null;
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(`estudios-medicos/${candidatoNPId}?${query && query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);
  return res.success;
};

export const postMedicalStudies = async (candidato) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(`estudios-medicos`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(candidato),
    // "candidatoNPId":1,
    // "fechaExamen":"2024-05-10",
    // "notaDePedidoId":1,
    // "proveedor":1,
    // "tipo":"Tipo"
  });

  res = await parseJSON(res);

  return res.success;
};

export const patchMedicalStudies = async (candidato, estudioId) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(`estudios-medicos/${estudioId}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(candidato),
  });

  res = await parseJSON(res);

  return res.success;
};

export const getProveedoresMedicalStudies = async (params) => {
  const query = params ? new URLSearchParams(params) : null;

  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(`estudios-medicos/proveedores?${query && query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);
  return res.success;
};

export const getInterviews = async (candidatoNPId, params) => {
  const query = params ? new URLSearchParams(params) : null;
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(`entrevistas/${candidatoNPId}?${query && query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);
  return res.success;
};

export const postInterviews = async (candidato) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(`entrevistas`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(candidato),
  });

  res = await parseJSON(res);

  return res.success;
};

export const patchInterviews = async (candidato, interviewId) => {
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(`entrevistas/${interviewId}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(candidato),
  });

  res = await parseJSON(res);

  return res.success;
};

// para export de ordenes de venta
export const exportCandidatos = async (params) => {
  const auth = `Bearer ${getToken()}`;
  const query = new URLSearchParams(params);
  const res = await fetch(readUrl(`/export?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  const blob = await res.blob();
  return blob;
};

export const getKPICandidatos = async (notaDePedidoId) => {
  if (!notaDePedidoId) return [];
  const auth = `Bearer ${getToken()}`;
  let res = await fetch(readUrl(`/KPICandidatos?notaDePedidoId=${notaDePedidoId}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });
  res = await parseJSON(res);
  return res.success;
};
